<template>
  <div class="container-xl" v-if="info">
    <div class="section__title text-center">
      <h2 class="title">
        {{ $t('main-nav.sustainability') }}
      </h2>
    </div>

    <Media
      data-gtm-section="Sustainability"
      data-gtm-subsection="Sustainability Video"
      data-gtm-label="Watch Video"
      :src="getDataByPrinter.video_source"
      @click.stop="clickTracked($event)"/>

    <ShareButton
      :hash="hashify(`Sustainability Video ${currentPrinter}`)"
      :shareLabel="`${$t('main-nav.sustainability')} - ${$t('sustainability.submenu.video')}`"
      :shareLink="(getDataByPrinter.video_source.indexOf('.mp4') >= 0)
        ? `${baseURL}${getDataByPrinter.video_source}`
        : getDataByPrinter.video_source"
      @share-this="shareThis" />
  </div>
</template>

<script>
import axios from 'axios';

import * as endpoints from '@/common/endpoints';
import { filters, defaultMixins } from '@/common/mixins';

import Media from '@/components/ui/Media.vue';
import ShareButton from '@/components/ui/ShareButton.vue';

export default {
  name: 'SustainabilityVideo',
  mixins: [filters, defaultMixins],
  components: {
    Media,
    ShareButton,
  },
  data() {
    return {
      baseURL: endpoints.BASEURL,
      info: null,
    };
  },
  created() {
    axios.get(`${endpoints.CMS}items/sustainability_video`, {
      params: {
        fields: '*,translations.*,printer.printers_id',
      },
    })
      .then(({ data: { data } }) => {
        this.info = data;
      });
  },
  mounted() {
    this.showMainTabs();
  },
};
</script>
